import globalConfig from '@utiles/officialStore/globalConfig';
import gameInfoConfig from '@/resource/configs/officialStore/globalGameInfoConfig';
import { getJSON, PASSPORT_HOST } from './ultile';
import { HTTP } from './index';
import { updateDefaultParam } from '../../plugins/AnalyzePoint';
import languages from '../languages';
const hostname = window.location.hostname;
let arr = hostname.split('.');
export const EVENT_HOST = `//gactivityapi.${arr[1]}.com/activity/execute?name=ztmslgpay&action=`;
export const EVENT_BASIC = 'basic';
export const EVENT_CREATE_CODE = 'generateCode';
export const EVENT_BIND_CODE = 'bindCode';
export const EVENT_GET_AWARD = 'award';
export const EVENT_BAG = 'awardLog';
export const SET_BLOCK = 'set_block';
export const SET_TIP_POPUP_SHOW_STATUS = 'set_tip_popup_show_status';
export const SET_BAG_POPUP_SHOW_STATUS = 'set_bag_popup_show_status';
export const SET_RULE_POPUP_SHOW_STATUS = 'set_rule_popup_show_status';
export const UPDATE_LOGIN_STATE = 'update_login_state';
export const UPDATE_CREATE_STATE = 'update_create_state';
export const UPDATE_BIND_STATE = 'update_bind_state';
export const UPDATE_INVITE_NUM = 'update_invite_num';
export const UPDATE_INVITE_PAY_TOTAL = 'update_invite_pay_total';
export const UPDATE_INVITE_LIST = 'update_invite_list';
export const UPDATE_NEED_STATE = 'update_need_state';
export const UPDATE_AWARD_LOG = 'update_award_log';
export const UPDATE_MYPAY_INFO = 'update_mypay_info';
export const UPDATE_ONE_STATUS = 'update_one_status';
export const UPDATE_TWO_STATUS = 'update_two_status';
export const BIND_CODE = 'bind_code';
export const CREATE_CODE = 'create_code';
export const LOAD_EVENT_BASIC = 'load_event_basic';
export const GET_AWARD = 'get_award';
export const GET_AWARD_LOG = 'get_award_log';
export const GET_LOGIN = 'get_login';
const CHECK_LOGIN_ACTION = 'center/ajax/get_store_user_json';
export const UPDATE_LOGIN_STATUS = 'update_login_status';
export const EVENT_IS_LOGIN = 'event_is_login';

const GAMEID = globalConfig.getHrefParam('gameId');
const BLACK_FRIDAY_SIGN = {
  // pns
  191: 'pns_bf_2023',
  225: 'pns_bf_2023',
  227: 'pns_bf_2023',
  284: 'pns_bf_2023',
  //蚂蚁
  263: 'ant_bf_2023'
};
export const BLACK_FRIDAY_HOST = `//gactivityapi.${arr[1]}.com/activity/execute?name=${BLACK_FRIDAY_SIGN[GAMEID]}&action=`;
export const BLACK_FRIDAY_BASIC = 'basic';
export const BLACK_FRIDAY_GET_SCORE = 'award';
export const BLACK_FRIDAY_EXCHANGE = 'exchange';
export const UPDATE_BF_SCORE = 'update_bf_score';

export const LIMITED_TIME_ACTIVITY_BASE = `//gactivityapi.${arr[1]}.com/activity/execute?`;
export const LIMITED_TIME_ACTIVITY_BASIC = `basic`;
export const LIMITED_TIME_ACTIVITY_AWARD = `award`;
export const LIMITED_TIME_ACTIVITY_AWARD_LOG = `awardLog`;
export const UPDATE_LIMITED_TIME_ACTIVITY_SHOW = `update_limited_time_activity_show`;
export const UPDATE_LIMITED_TIME_ACTIVITY_TIME = `update_limited_time_activity_time`;

export default {
  state: {
    isLogin: false, // 是否登录
    curLanguage: languages.getLanguage(),
    isShowEventTipPopup: false, //是否展示提示弹窗
    isShowBagPopup: false, //是否展示背包弹窗
    isShowRulePopup: false, //是否展示规则弹窗
    isNeedAward: false, // 是否有可领奖励未领
    isBindCode: false, // 是否已绑定邀请码
    isCreateCode: false, // 是否已生成邀请码
    invitationCode: '', // 我的邀请码
    invitationLink: '', // 我的邀请链接
    bindInvitationCode: '', // 绑定的邀请码
    myPay: 0, // 我的储值总额
    inviteNum: 0, // 邀请人数
    invitePayTotal: 0, // 邀请人储值总额
    inviteList: [], // 邀请人列表
    awardLog: [], // 背包列表
    myPayInfo: {}, // 个人储值情况
    isComplete1: false, // 加码奖励1完成情况
    isComplete2: false, // 加码奖励2完成情况
    block: '1', // 模块

    // 黑五活动
    bfScore: 0, // 黑五剩余积分
    bfHasAward: 0, // 是否用礼包码兑换了积分奖励
    bfTime: 0, // 黑五活动剩余时间（秒）
    bfTimer: null, // 黑五活动倒计时

    // 限时活动
    limitedTimeActivityShow: false, // 限时活动是否展示
    limitedTimeActivityMonthStart: 0, // 当前月的开始时间戳（UTC时间）
    limitedTimeActivityMonthEnd: 0 // 当前月的结束时间戳（UTC时间）
  },
  getters: {},
  mutations: {
    [SET_BLOCK](state, num) {
      state.block = num;
    },
    [SET_TIP_POPUP_SHOW_STATUS](state, status) {
      state.isShowEventTipPopup = status;
    },
    [SET_BAG_POPUP_SHOW_STATUS](state, status) {
      state.isShowBagPopup = status;
    },
    [SET_RULE_POPUP_SHOW_STATUS](state, status) {
      state.isShowRulePopup = status;
    },
    [UPDATE_LOGIN_STATUS](state, status) {
      state.isLogin = status;
    },
    [UPDATE_CREATE_STATE](state, code) {
      state.isCreateCode = true;
      state.invitationCode = code;
      state.invitationLink =
        'https://pay.' +
        arr[1] +
        '.com/platform/officialStore.html?gameId=191&shareCode=' +
        code +
        '#/share_event';
    },
    [UPDATE_BIND_STATE](state, code) {
      state.isBindCode = true;
      state.bindInvitationCode = code;
    },
    [UPDATE_INVITE_NUM](state, num) {
      state.inviteNum = num;
    },
    [UPDATE_INVITE_PAY_TOTAL](state, total) {
      state.invitePayTotal = total;
    },
    [UPDATE_INVITE_LIST](state, list) {
      state.inviteList = list;
    },
    [UPDATE_NEED_STATE](state, status) {
      state.isNeedAward = status;
    },
    [UPDATE_AWARD_LOG](state, list) {
      state.awardLog = list;
    },
    [UPDATE_MYPAY_INFO](state, info) {
      state.myPayInfo = info;
    },
    [UPDATE_ONE_STATUS](state, status) {
      state.isComplete1 = status;
    },
    [UPDATE_TWO_STATUS](state, status) {
      state.isComplete2 = status;
    },
    [UPDATE_BF_SCORE](state, score) {
      state.bfScore = score;
    },
    [UPDATE_LIMITED_TIME_ACTIVITY_SHOW](state, status) {
      state.limitedTimeActivityShow = status;
    },
    [UPDATE_LIMITED_TIME_ACTIVITY_TIME](state, data) {
      state.limitedTimeActivityMonthStart = data.monthStart * 1000;
      state.limitedTimeActivityMonthEnd = data.monthEnd * 1000;
    }
  },
  actions: {
    [EVENT_IS_LOGIN]({ commit }) {
      return new Promise(resolve => {
        getJSON(HTTP + PASSPORT_HOST + CHECK_LOGIN_ACTION, {}).then(res => {
          if (parseInt(res.res.result, 10) === 1) {
            commit(UPDATE_LOGIN_STATUS, true);
            updateDefaultParam('loginAccount', res.res.data.LOGIN_ACCOUNT);
            updateDefaultParam('ext14', res.res.data.UID);
          }
          resolve(res.res);
        });
      });
    },
    [LOAD_EVENT_BASIC]({ commit }) {
      return new Promise((resolve, reject) => {
        getJSON(EVENT_HOST + EVENT_BASIC, {}).then(res => {
          if (+res.res.code === 1) {
            res.res.data.isBind &&
              commit(UPDATE_BIND_STATE, res.res.data.bindCode);
            res.res.data.isGenerate &&
              commit(UPDATE_CREATE_STATE, res.res.data.myCode);
            res.res.data.inviteNum &&
              commit(UPDATE_INVITE_NUM, res.res.data.inviteNum);
            res.res.data.invitePayTotal &&
              commit(UPDATE_INVITE_PAY_TOTAL, res.res.data.invitePayTotal);
            res.res.data.inviteList &&
              commit(UPDATE_INVITE_LIST, res.res.data.inviteList);
            res.res.data.needAward &&
              commit(UPDATE_NEED_STATE, res.res.data.needAward);
            res.res.data.myPayInfo &&
              commit(UPDATE_MYPAY_INFO, res.res.data.myPayInfo);
            res.res.data.off12 && commit(UPDATE_ONE_STATUS, res.res.data.off12);
            res.res.data.off15 && commit(UPDATE_TWO_STATUS, res.res.data.off15);
            resolve(res.res);
          } else {
            reject(res.res);
          }
        });
      });
    },
    [BIND_CODE]({ commit }, params) {
      return new Promise((resolve, reject) => {
        getJSON(EVENT_HOST + EVENT_BIND_CODE, {
          params: params
        }).then(res => {
          if (+res.res.code === 1) {
            res.res.data && commit(UPDATE_BIND_STATE, res.res.data);
            resolve(res.res);
          } else {
            reject(res.res);
          }
        });
      });
    },
    [CREATE_CODE]({ commit }) {
      return new Promise((resolve, reject) => {
        getJSON(EVENT_HOST + EVENT_CREATE_CODE, {}).then(res => {
          if (+res.res.code === 1) {
            res.res.data && commit(UPDATE_CREATE_STATE, res.res.data);
            resolve(res.res);
          } else {
            reject(res.res);
          }
        });
      });
    },
    [GET_AWARD]({ _commit }) {
      return new Promise((resolve, reject) => {
        getJSON(EVENT_HOST + EVENT_GET_AWARD, {}).then(res => {
          if (+res.res.code === 1) {
            resolve(res.res);
          } else {
            reject(res.res);
          }
        });
      });
    },
    [GET_AWARD_LOG]({ commit }) {
      return new Promise((resolve, reject) => {
        getJSON(EVENT_HOST + EVENT_BAG, {}).then(res => {
          if (+res.res.code === 1) {
            res.res.data && commit(UPDATE_AWARD_LOG, res.res.data);
            resolve(res.res);
          } else {
            reject(res.res);
          }
        });
      });
    },
    //黑五活动
    [BLACK_FRIDAY_BASIC]({ state, rootState }, params) {
      return new Promise((resolve, reject) => {
        getJSON(BLACK_FRIDAY_HOST + BLACK_FRIDAY_BASIC, {
          params: params
        }).then(res => {
          // 20015活动未开启 20016活动已结束
          rootState.isBlackFridayStart = ![-20015, -20016].includes(
            +res.res.code
          );
          if (+res.res.code === 1 && res.res.data) {
            const info = res.res.data;
            state.bfScore = info.score;
            state.bfHasAward = info.isAward;
            state.bfTime = info.time;
            clearInterval(state.bfTimer);
            //设置倒计时
            state.bfTimer = setInterval(() => {
              if (state.bfTime <= 0) {
                clearInterval(state.bfTimer);
                return;
              }
              state.bfTime--;
            }, 1000);
            resolve(res.res);
          } else {
            reject(res.res);
          }
        });
      });
    },
    [BLACK_FRIDAY_GET_SCORE]({ commit }, params) {
      return new Promise((resolve, reject) => {
        getJSON(BLACK_FRIDAY_HOST + BLACK_FRIDAY_GET_SCORE, {
          params: params
        }).then(res => {
          if (+res.res.code === 1) {
            res.res.data && commit(UPDATE_BF_SCORE, res.res.data.score);
            resolve(res.res);
          } else {
            reject(res.res);
          }
        });
      });
    },
    [BLACK_FRIDAY_EXCHANGE]({ commit }, params) {
      return new Promise((resolve, reject) => {
        getJSON(BLACK_FRIDAY_HOST + BLACK_FRIDAY_EXCHANGE, {
          params: params
        }).then(res => {
          if (+res.res.code === 1) {
            res.res.data && commit(UPDATE_BF_SCORE, res.res.data.score);
            resolve(res.res);
          } else {
            reject(res.res);
          }
        });
      });
    },
    [LIMITED_TIME_ACTIVITY_BASIC]({ commit, rootGetters }, params) {
      return new Promise((resolve, reject) => {
        const activitySign =
          rootGetters.gameInfoConfig.limitedTimeActivity.activitySign;
        getJSON(
          `${LIMITED_TIME_ACTIVITY_BASE}name=${activitySign}&action=${LIMITED_TIME_ACTIVITY_BASIC}`,
          { params }
        ).then(res => {
          if (+res.res.code === 1) {
            resolve(res.res);
            commit(UPDATE_LIMITED_TIME_ACTIVITY_TIME, res.res.data);
            commit(UPDATE_LIMITED_TIME_ACTIVITY_SHOW, true);
          } else {
            commit(UPDATE_LIMITED_TIME_ACTIVITY_SHOW, false);
            reject(res.res);
          }
        });
      });
    },
    [LIMITED_TIME_ACTIVITY_AWARD]({ commit, rootGetters }, params) {
      return new Promise((resolve, reject) => {
        const activitySign =
          rootGetters.gameInfoConfig.limitedTimeActivity.activitySign;
        getJSON(
          `${LIMITED_TIME_ACTIVITY_BASE}name=${activitySign}&action=${LIMITED_TIME_ACTIVITY_AWARD}`,
          {
            params: params
          }
        ).then(res => {
          if (+res.res.code === 1) {
            resolve(res.res);
          } else {
            reject(res.res);
          }
        });
      });
    },
    [LIMITED_TIME_ACTIVITY_AWARD_LOG]({ commit, rootGetters }, params) {
      return new Promise((resolve, reject) => {
        const activitySign =
          rootGetters.gameInfoConfig.limitedTimeActivity.activitySign;
        getJSON(
          `${LIMITED_TIME_ACTIVITY_BASE}name=${activitySign}&action=${LIMITED_TIME_ACTIVITY_AWARD_LOG}`,
          { params: params }
        ).then(res => {
          if (+res.res.code === 1) {
            resolve(res.res);
          } else {
            reject(res.res);
          }
        });
      });
    }
  }
};
